import { Quote } from "lucide-react";

interface PullQuoteProps {
  text: string;
  author?: string;
}

export const PullQuote = ({ text, author }: PullQuoteProps) => {
  return (
    <div className="my-16 border-l-4 border-primary pl-8 py-6 relative">
      <Quote className="absolute -left-3 top-0 h-8 w-8 text-primary/20" />
      <blockquote className="text-2xl md:text-3xl font-serif italic text-foreground leading-relaxed">
        "{text}"
      </blockquote>
      {author && (
        <cite className="block mt-4 text-sm uppercase tracking-wide text-muted-foreground not-italic">
          — {author}
        </cite>
      )}
    </div>
  );
};
